/**
 * In-memory token storage to prevent XSS attacks.
 * Tokens stored here are not accessible via JavaScript from external scripts.
 * Note: Token will be lost on page refresh, but refresh token in httpOnly cookie
 * will be used to obtain a new access token.
 */

let accessToken: string | null = null;

/**
 * Get the current access token from memory
 */
export const getAccessToken = (): string | null => {
  return accessToken;
};

/**
 * Set the access token in memory
 */
export const setAccessToken = (token: string | null): void => {
  accessToken = token;
};

/**
 * Remove the access token from memory
 */
export const removeAccessToken = (): void => {
  accessToken = null;
};

